export const messagesSE = {};
